'use strict';

angular.module('amexReconciliationApp')
  .component('travelDataModal', {
    templateUrl: 'scripts/views/modals/travel-data-modal.html',
    bindings: {
      closeModalCallback: '&',
      transactions: '<'
    },
    controller: function ($scope,
                          TpdModel,
                          BillingCycleModel,
                          SiteConfigModel,
                          PaginationModelFactory,
                          TransactionsModel,
                          TpdSortModel,
                          UserModel,
                          $filter,
                          $translate,
                          toastr,
                          AssociateAccountingDetailsRepository) {
      var self = this;
      var selectedTpdId;
      var copyAccountingDetailsButtonPressed = false;
      var PAGE_SIZE = 20;
      var tpdPaginationModel = PaginationModelFactory.create(PAGE_SIZE);

      var tpdFilter = $filter('tpdFilter');

      self.pageStart = tpdPaginationModel.pageStart;
      self.pageEnd = tpdPaginationModel.pageEnd;
      self.pageSize = tpdPaginationModel.pageSize;
      self.currentPage = tpdPaginationModel.pageNumber;
      self.totalCount = tpdPaginationModel.totalCount;
      self.showPagination = tpdPaginationModel.showPagination;
      self.updateCurrentPage = tpdPaginationModel.updateCurrentPage;
      self.tpdsOnCurrentPage = tpdPaginationModel.recordsOnCurrentPage;
      self.tpds = [];
      
      self.closeModal = self.closeModalCallback;
      self.BillingCycleModel = BillingCycleModel;
      self.currentTpdBillingCycle = self.BillingCycleModel.billingCycles()[0];
      self.getCurrencyFormat = UserModel.getCurrencyFormat;

      self.showUnlinkedOnly = true;

      self.tpdLoading = function () {
        return TpdModel.loading();
      };

      self.handleBillingCycleChange = function () {
        selectedTpdId=undefined;
        TpdModel.getTpd(self.transactions, self.currentTpdBillingCycle, self.showUnlinkedOnly);
      };

      TpdModel.onThirdPartyDataChanged($scope, function(tpds) {
        self.tpds = tpds;
        tpdPaginationModel.repaginate(getFilteredAndSortedTpds());
      });

      self.handleBillingCycleChange();

      self.selectTpdRow = function (tpdId) {
        selectedTpdId = tpdId;
      };

      self.rowIsSelected = function (tpdId) {
        if (tpdId === selectedTpdId) {
          return true;
        }
        return false;
      };

      self.copyAccountingDetailsButtonDisabled = function () {
        if (copyAccountingDetailsButtonPressed || selectedTpdId === undefined ||
            self.transactions[0].lockStatus === 'FULLY_LOCKED' || self.transactions[0].lockStatus === 'PARTIALLY_LOCKED') {
          return true;
        }
        return false;
      };

      self.linkTravelDataButtonDisabled = function () {
        if (copyAccountingDetailsButtonPressed || selectedTpdId === undefined) {
          return true;
        }
        return false;
      };

      self.copyAccountingDetails = function () {
        copyAccountingDetailsButtonPressed = true;

        var selectedTransactionIds = _.map(self.transactions, 'id');

        AssociateAccountingDetailsRepository.copy(selectedTransactionIds, selectedTpdId)
          .then(function () {
            TransactionsModel.refreshTransactions(selectedTransactionIds)
              .then(function() {
                self.transactions = updateSelectedTransactions(selectedTransactionIds);
              })
              .then(successCopyingCallback)
              .catch(errorCopyingCallback);
          })
          .catch(errorCopyingCallback)
          .finally(function() {self.closeModal();});
      };

      self.linkTravelData = function () {
        copyAccountingDetailsButtonPressed = true;

        var selectedTransactionIds = _.map(self.transactions, 'id');

        AssociateAccountingDetailsRepository.link(selectedTransactionIds, selectedTpdId)
          .then(function () {
            TransactionsModel.refreshTransactions(selectedTransactionIds)
              .then(function() {
                self.transactions = updateSelectedTransactions(selectedTransactionIds);
              })
              .then(successLinkingCallback)
              .catch(errorLinkingCallback);
          })
          .catch(errorLinkingCallback)
          .finally(function() {self.closeModal();});
      };

      self.populateFilter = function ($event) {
        self.tpdSearchTerm = _.words($event.target.text, /[^\s]+/g).join(' ');
        self.filterChanged();
      };

      self.filterChanged = function () {
        tpdPaginationModel.repaginate(getFilteredAndSortedTpds());
      };

      TpdSortModel.onSortOrderChanged($scope, function () {
        tpdPaginationModel.repaginate(getFilteredAndSortedTpds());
      });

      function getFilteredAndSortedTpds() {
        return TpdSortModel.applySort(tpdFilter(self.tpds, self.tpdSearchTerm, self.getCurrencyFormat()));
      }

      function successLinkingCallback() {
        if(anyInvalidTravelDataAccountingValues()) {
          toastr.success($translate.instant('thirdPartyData.travelDataSuccessfulLinkAndCopyWithDefaults'));
        } else {
          toastr.success($translate.instant('thirdPartyData.travelDataSuccessfulLinkAndCopy'));
        }
      }

      function successCopyingCallback() {
        if(anyInvalidTravelDataAccountingValues()) {
          toastr.success($translate.instant('thirdPartyData.travelDataSuccessfulCopyWithDefaults'));
        } else {
          toastr.success($translate.instant('thirdPartyData.travelDataSuccessfulCopy'));
        }
      }

      function errorLinkingCallback() {
        toastr.error('Error linking travel data.');
      }

      function errorCopyingCallback() {
        toastr.error('Error copying travel data.');
      }

      function anyInvalidTravelDataAccountingValues() {
        return _.some(self.transactions, function(transaction){
          return _.includes(_.get(transaction, 'details.exceptionNote', ''), '@EXC_VALID_MULTI');
        });
      }

      function updateSelectedTransactions(selectedTransactionIds) {
        return _.filter(TransactionsModel.transactions(),function(transaction) {
          return _.includes(selectedTransactionIds, _.get(transaction, 'id', ''));});
      }
    }
  });




//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/travelDataModal.js
// module id = 500
// module chunks = 0